import React, { createContext, useContext, useState, useCallback } from "react";

const PopupContext = createContext(null);

export const PopupProvider = ({ children }) => {
  const [isPopUpOpen, setIsPopUpOpen] = useState(false);
  const [popUpComponent, setPopUpComponent] = useState(null);

  const [isScreenshotPopUpOpen, setIsScreenshotPopUpOpen] = useState(false);
  const [currentScreenshotForPopUp, setCurrentScreenshotForPopUp] =
    useState(null);

  const openPopUp = useCallback((component) => {
    setPopUpComponent(component);
    setIsPopUpOpen(true);
  }, []);

  const closePopUp = useCallback(() => {
    setIsPopUpOpen(false);
    setPopUpComponent(null);
  }, []);

  return (
    <PopupContext.Provider
      value={{
        isPopUpOpen,
        setIsPopUpOpen,
        popUpComponent,
        setPopUpComponent,
        openPopUp,
        closePopUp,
        isScreenshotPopUpOpen,
        setIsScreenshotPopUpOpen,
        currentScreenshotForPopUp,
        setCurrentScreenshotForPopUp,
      }}
    >
      {children}
    </PopupContext.Provider>
  );
};

export const usePopup = () => {
  const ctx = useContext(PopupContext);
  if (!ctx) throw new Error("usePopup must be used within PopupProvider");
  return ctx;
};

export default PopupContext;
